import { sha512 } from 'js-sha512';

const generateTransactionHash = (fromAccount: string, toAccount: string): string => {
  const ss = `${fromAccount}${toAccount}`;
  return sha512(ss);
};

export default generateTransactionHash;
